/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Next_DifferenceInputs */

const en_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Difference`)
};

const fr_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différence suivante`)
};

const de_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Unterschied`)
};

const it_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenza successiva`)
};

const ru_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующая разница`)
};

const es_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima diferencia`)
};

const zh_cn2_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个区别`)
};

const ja_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の違い`)
};

const hi_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला अंतर`)
};

const pt_pt2_compare_event_groups_next_difference = /** @type {(inputs: Compare_Event_Groups_Next_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima diferença`)
};

/**
* | output |
* | --- |
* | "Next Difference" |
*
* @param {Compare_Event_Groups_Next_DifferenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_next_difference = /** @type {((inputs?: Compare_Event_Groups_Next_DifferenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Next_DifferenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_next_difference(inputs)
	if (locale === "de") return de_compare_event_groups_next_difference(inputs)
	if (locale === "it") return it_compare_event_groups_next_difference(inputs)
	if (locale === "ru") return ru_compare_event_groups_next_difference(inputs)
	if (locale === "es") return es_compare_event_groups_next_difference(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_next_difference(inputs)
	if (locale === "ja") return ja_compare_event_groups_next_difference(inputs)
	if (locale === "hi") return hi_compare_event_groups_next_difference(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_next_difference(inputs)
	return en_compare_event_groups_next_difference(inputs)
});